import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { Document, Page, PDFViewer, Text, View } from "@react-pdf/renderer";
import PDFTable from "../../../components/react-pdf-table";


const GradesReport = ({ data }) => {

    const buildStudentReport = (activity) => {
        const rows = [];

        activity.tasks
            .filter(task => task.requires_grade)
            .forEach(task => {
                task.task_completions.forEach(completion => {

                    completion.team.team_memberships.forEach(tm => {
                        rows.push({
                            studentName: tm.user_context.user.name,
                            roleName: tm.role.name,
                            taskName: task.name,
                            taskOrder: task.order,
                            teamName: completion.team.name,
                            grade: completion.grade || '-',
                        });
                    });
                });
            });

        return rows.sort((a, b) => {
            if (a.studentName > b.studentName) { return 1 }
            else if (a.studentName < b.studentName) { return -1 }
            else { return a.taskOrder - b.taskOrder }
        });
    }

    const reportData = buildStudentReport(data)

    const headers = [
        { id: 'studentName', text: 'Aluno', width: '30%' },
        { id: 'taskName', text: 'Movimentação', width: '25%' },
        { id: 'teamName', text: 'Equipe', width: '10%' },
        { id: 'roleName', text: 'Sujeito processual', width: '20%' },
        { id: 'grade', text: 'Nota', width: '5%' },
    ]

    return (
        <PDFViewer width={'100%'} height={'600px'}>
            <Document>
                <Page orientation="landscape">
                    <View style={{ margin: '16px', padding: '4px', borderRadius: '4px', border: '1px solid black', textAlign: 'center', fontWeight: 'light' }}>
                        <Text style={{ fontSize: '16' }}>Relatório de notas</Text>
                        <Text style={{ fontSize: '14' }}>{`Atividade ${data.name}`}</Text>
                        <Text style={{ fontSize: '14' }}>{`Turma ${data.class.name}`}</Text>
                        <Text style={{ fontSize: '12' }}>Emitido em {new Date().toLocaleString()}</Text>
                    </View>

                    <PDFTable headers={headers} data={reportData} />

                </Page>
            </Document>
        </PDFViewer>
    )
}

export const ReportDialog = ({ open, onClose, data, ...props }) => {
    return <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
        <DialogTitle>
            {`Relatório de notas da atividade ${data?.id}`}
        </DialogTitle>
        <DialogContent>
            <GradesReport data={data}></GradesReport>
        </DialogContent>
        <DialogActions>
            <Button startIcon={<Close />} children={'Fechar'} onClick={onClose} />
        </DialogActions>
    </Dialog>
}